<template>
  <div>
    <v-layout class="systock-breadcrump" align-center>
      <v-flex xs5>
        <v-breadcrumbs :items="items" dark>
          <template v-slot:item="{item}">
            <v-breadcrumbs-item :class="[item.disabled && 'disabled']" class="d-flex align-center cursor-pointer">
              <NomeFornecedorMenu :fornecedor="item" @push-dashboard="routerPushGrupo" />

              <template v-if="item.config">
                <config-fornecedor @atualizar-tela-compras="$emit('atualizar-tela-compras')" title="Configuração do Fornecedor" />
                <DropDownFiltros :id_comprador="comprador.id"/>
                <silenciar-fornecedor />
              </template>
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </v-flex>
      <v-flex xs2 class="text-lg-center">
        <h4
          v-show="produtoSilenciadoQtde > 0"
          style="color: #d60e2b; cursor: pointer"
          @click="setDialogProdutosSilenciados(true)"
        >
          ITENS SILENCIADOS
          <v-icon small color="#D60E2B">mdi-bell-off</v-icon>
          <span id="qtde-silenciados">{{ produtoSilenciadoQtde }}</span>
        </h4>
      </v-flex>
      <v-flex xs4 class="text-lg-center">
        <v-autocomplete
          v-model="fornecedorSelecionado"
          :items="fornecedores"
          label="Digite o nome do fornecedor"
          clearable
          color="white"
          dark
          item-text="razao_social"
          return-object
          dense
          class="font-padrao-label pt-3"
        >
          <template slot="selection" slot-scope="data">
            <span class="font-padrao-input">{{ data.item.razao_social }}</span>
          </template>
          <template slot="item" slot-scope="data">
            <span class="font-padrao-input">{{ data.item.razao_social }} </span>
          </template>
        </v-autocomplete>
      </v-flex>
      <v-flex xs1 class="text-lg-center">
        <v-btn
          color="#A51B32"
          style="color: #fff"
          class="mb-2"
          @click="buscarCompraFornecedor(fornecedorSelecionado)"
          >Buscar</v-btn
        >
      </v-flex>
    </v-layout>
    <!-- Modal do Lista de Fornecedores a Ressuprir -->
    <v-layout justify-center>
      <DialogFornecedoresRessuprir
        v-model="dialogListaFornecedor"
        :desserts_tabela="itensListaFornecedor"
        :comprador="{ nome: comprador.nome_completo, id: comprador.id }"
      />
      <!-- <v-dialog
        v-model="dialogListaFornecedor"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card style="padding: 0% 0% 1% 0%">
          <v-toolbar dark color="#042333">
            <v-btn icon dark @click="dialogListaFornecedor = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Lista de Fornecedores em Ressuprimento</v-toolbar-title>

            <v-spacer />

            <v-btn color="primary" small @click="exportarFornecedoresEmRessuprimento">
              <v-icon left>mdi-file-export</v-icon>
              exportar
            </v-btn>
          </v-toolbar>
          <v-layout style="padding: 0px 3px 0px 3px">
            <v-data-table
              :headers="headersListaFornecedor"
              :items="itensListaFornecedor"
              :items-per-page="-1"
              :fixed-header="true"
              :height="380"
              class="elevation-0 table-full-screen-responsiva table-full-screen"
              style="width: 100%; cursor: pointer"
              item-key="id"
              :search="search_comp"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <h3>Comprador(a) : {{ comprador.nome_completo }}</h3>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-text-field
                    label="Pesquisar"
                    clearable
                    outlined
                    dense
                    class="mt-7"
                    v-model="search_comp"
                    style="max-width: 550px"
                    v-lazy-input:debounce="500"
                  ></v-text-field>
                </v-toolbar>
              </template>
              <template v-slot:item="props">
                <tr
                  @click="
                    buscarFornecedor(props.item, 2);
                    activerow(props.item);
                  "
                  :class="{ selected_row: `${props.item.id}-${props.item.id_grupo}` === selectedId }"
                >
                  <td>{{ props.item.nome_grupo }}</td>
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.razao_social }}</td>
                  <td>{{ props.item.data_ultima_analise }}</td>
                  <td>{{ props.item.qtde_dias_ultima_analise == 0 ? "Hoje" : props.item.qtde_dias_ultima_analise }}</td>
                  <td>
                    <v-badge
                      color="white"
                      overlap
                      v-if="props.item.cotacao > 0"
                    >
                      <template v-slot:badge>
                        <h4 style="color: #000">
                          {{ props.item.qtde_item_cotacao }}
                        </h4>
                      </template>
                      <v-icon title="Compra em processo de Cotação"
                        >mdi-phone-log</v-icon
                      >
                    </v-badge>
                  </td>
                  <td>{{ props.item.dias_em_cotacao }}</td>
                  <td>{{ props.item.qtde_geral_itens }}</td>
                  <td>{{ props.item.qtde_itens_ok }}</td>
                  <td>{{ props.item.qtde_itens_ressuprir }}</td>
                  <td>{{ props.item.qtde_itens_transito }}</td>
                  <td>
                    {{
                      Helpers.formatarValorMonetario(props.item.total_ressuprir)
                    }}
                  </td>
                  <td>
                    <v-btn icon>
                      <v-icon>{{ props.item.icon_compra }}</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-layout>
        </v-card>
      </v-dialog> -->
    </v-layout>
    <!-- Modal do Lista de Segmentos a Ressuprir -->
    <v-layout justify-center>
      <v-dialog
        v-model="dialogListaSegmentosComprador"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card style="padding: 0% 0% 1% 0%">
          <v-toolbar dark color="#042333">
            <v-btn icon dark @click="dialogListaSegmentosComprador = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title
              >Lista de Segmentos em Ressuprimento</v-toolbar-title
            >
          </v-toolbar>
          <v-layout style="padding: 0px 3px 0px 3px">
            <v-data-table
              :headers="headersListaSegmentosComprador"
              :items="itensListaSegmentosComprador"
              :items-per-page="-1"
              :fixed-header="true"
              :height="380"
              class="elevation-0 table-full-screen-responsiva table-full-screen"
              :item-class="item => ({ 'bg-gray-300': `${item.id}-${item.id_grupo}` === selectedId })"
              style="width: 100%; cursor: pointer"
              :calculate-widths="true"
              :search="search_comp"
              item-key="id"
              @click:row="buscarFornecedorSegmento($event);activerow($event);"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <h3>Segmentos/Categoria: {{ segmento.nome_completo }}</h3>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-text-field
                    label="Pesquisar"
                    clearable
                    class="mt-7"
                    outlined
                    dense
                    style="max-width: 550px"
                    v-model="search_comp"
                    v-lazy-input:debounce="500"
                  ></v-text-field>
                </v-toolbar>
              </template>

              <template #item.cotacao="{ item }">
                <v-badge
                  color="white"
                  overlap
                  v-if="item.cotacao > 0"
                >
                  <template v-slot:badge>
                    <h4 style="color: #000">
                      {{ item.qtde_item_cotacao }}
                    </h4>
                  </template>
                  <v-icon title="Compra em processo de Cotação"
                    >mdi-phone-log</v-icon
                  >
                </v-badge>
              </template>

              <template #item.total_ressuprir="{ item }">
                {{ Helpers.formatarValorMonetario(item.total_ressuprir) }}
              </template>

              <template #item.icon_compra="{ item }">
                <v-icon>{{ item.icon_compra }}</v-icon>
              </template>
            </v-data-table>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- Modal de produtos Silenciados -->
    <produtos-silenciados />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import DashboardAPI from "./../../api/dashboard";
import { mapMutations } from "vuex";
import ProdutosSilenciados from "../produtoSilenciado/Listar";
import configFornecedor from "./fornecedor/index";
import DropDownFiltros from "@/components/compra/fornecedor/DropDownFiltros/Index.vue";
import SysDialogFullScreen from "../padraoDeLayout/SysDialogFullScreen.vue";
import Sazonalidade from "../cadastros/sazonalidade/Sazonalidade.vue";
import SilenciarFornecedor from "../produtoSilenciado/SilenciarFornecedor";
import $axios from '../../api/api.js';
import NomeFornecedorMenu from "./fornecedor/NomeFornecedorMenu";
import DialogFornecedoresRessuprir from "../dashboard/Fornecedores/DialogFornecedoresRessuprir.vue";

export default {
  props: ["atualizarSilenciadosBreadcrumb"],

  components: {
    NomeFornecedorMenu,
    ProdutosSilenciados,
    configFornecedor,
    DropDownFiltros,
    SysDialogFullScreen,
    Sazonalidade,
    SilenciarFornecedor,
    DialogFornecedoresRessuprir
},
  data: () => ({
    items: [],
    fornecedorSelecionado: "",
    fornecedores: [],
    search_comp: "",
    dialogListaFornecedor: false,
    dialogListaSegmentosComprador: false,
    headersListaFornecedor: [
      { text: "Grupo", value: "nome_grupo" },
      { text: "Código", value: "id" },
      { text: "Razão social", value: "razao_social" },
      { text: "Data da Últ. Análise", value: "data_ultima_analise" },
      { text: "Qtde dias da Últ. Análise", value: "qtde_dias_ultima_analise" },
      { text: "Cotação", value: "cotacao" },
      { text: "Dias em Cotação", value: "dias_em_cotacao" },
      { text: "Qtde.Produtos", value: "qtde_geral_itens" },
      { text: "Produtos Ok", value: "qtde_itens_ok" },
      { text: "Produtos Ressuprir", value: "qtde_itens_ressuprir" },
      { text: "Produtos Trânsito", value: "qtde_itens_transito" },
      { text: "Compra Prevista (Hoje)", value: "total_ressuprir" },
      { text: "", value: "icon_compra", sortable: false },
    ],
    itensListaFornecedor: [],
    selectedId: -1,
    segmento: {
      codigo: 0,
      nome_completo: "",
    },
    itensListaSegmentosComprador: [],
    headersListaSegmentosComprador: [
      { text: "Grupo", value: "nome_grupo" },
      { text: "Fornecedor", value: "idfornecedor" },
      { text: "Razão social", value: "razao_social" },
      { text: "Comprador", value: "nome_completo" },
      { text: "Cotação", value: "cotacao" },
      { text: "Dias em Cotação", value: "dias_em_cotacao" },
      { text: "Qtde.Produtos", value: "qtde_geral_itens" },
      { text: "Produtos Ok", value: "qtde_itens_ok" },
      { text: "Produtos Ressuprir", value: "qtde_itens_ressuprir" },
      { text: "Produtos com Venda Futura", value: "qtd_produtos_com_venda_futura" },
      { text: "Produtos Trânsito", value: "qtde_itens_transito" },
      { text: "Compra Prevista (Hoje)", value: "total_ressuprir" },
      { text: "", value: "icon_compra", sortable: false },
    ].filter(item => {
      return item.value !== 'qtd_produtos_com_venda_futura'
        || localStorage.existe_produtos_com_venda_futura === 'S';
    }),
  }),

  computed: {
    ...mapGetters({
      getFornecedor: "fornecedor/getFornecedor",
      comprador: "fornecedor/getComprador",
      grupoCompra: "usuario/getGrupoCompras",
      filialCompra: "usuario/getFilialCompras",
      activityLog: "activityLog/getLog"
    }),
    ...mapGetters("notificacaoProdutoSilenciado", ["produtoSilenciadoQtde"])
  },

  watch: {
    getFornecedor() {
      this.setarItensBreadcrumb();
      this.buscarQtdeProdutosSilenciados();
    },
    grupoCompra() {
      this.buscarFornecedores();
      this.buscarQtdeProdutosSilenciados();
    },
    filialCompra() {
      this.buscarQtdeProdutosSilenciados();
    },
    atualizarSilenciadosBreadcrumb() {
      this.buscarQtdeProdutosSilenciados();
    },
    activityLog() {
      const FUNCTION = this.activityLog.function;

      if (typeof this[FUNCTION] == "function") {
        this[FUNCTION](this.activityLog.properties.attributes);
      }
    },
  },

  created() {
    this.getFornecedor
      ? this.setarItensBreadcrumb()
      : this.$router.push({ name: "Dashboard" });
    this.buscarFornecedores();
    this.buscarQtdeProdutosSilenciados();
  },

  methods: {
    buscarCompraFornecedor(fornecedor_selecionado) {
      if (fornecedor_selecionado.grupo_analise_fornecedores) {
        localStorage.analiseGrupoFornecedores = 'S';
      } else {
        localStorage.analiseGrupoFornecedores = 'N';
      }

      this.Helpers.buscarCompraFornecedor(fornecedor_selecionado)
    },

    recarregarTelaCompras(fornecedor) {
      this.fornecedorSelecionado = fornecedor.fornecedor;
      const FORN = this.fornecedores.filter(
        (f) => f.id == fornecedor.fornecedor
      )[0];
      this.Helpers.buscarCompraFornecedor(FORN);

      this.$store.dispatch(
        "usuario/setFilialCompras",
        parseInt(fornecedor.filial_compra)
      );
      this.$store.dispatch(
        "usuario/setGrupoCompras",
        parseInt(fornecedor.grupo)
      );
    },

    ...mapMutations("app", ["setDialogProdutosSilenciados"]),

    buscarQtdeProdutosSilenciados() {
      if (this.getFornecedor.id >= 0) {
        const params = {
          grupo: this.grupoCompra,
          filial: this.filialCompra,
          comprador: this.comprador,
          fornecedor: this.getFornecedor.id,
          analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          this.$store.dispatch("notificacaoProdutoSilenciado/Qtde", params)
        );
      }
    },
    buscarFornecedor(id) {
      this.dialogListaFornecedor = false;
      this.Helpers.buscarCompraFornecedor(id, 2);
    },
    buscarFornecedorSegmento(item) {
      const comprador = {
        id: item.idcomprador,
        nome_completo: item.nome_completo,
      };

      this.$store.dispatch("fornecedor/setComprador", comprador);

      this.dialogListaSegmentosComprador = false;
      item.descricao_segmento = this.segmento.nome_completo;
      this.Helpers.buscarCompraFornecedorSegmento(item, 3);
    },

    activeDialog() {
      this.dialogListaFornecedor = true;
      this.itensListaFornecedor = [];

      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        comprador: this.comprador.id,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DashboardAPI.getListaFornecedoresComptadorTabela(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              response.data.fornecedores.forEach((fornecedor) => {
                fornecedor.icon_compra = "mdi-cart";
              });

              this.itensListaFornecedor = response.data.fornecedores;

              if (this.itensListaFornecedor.length) {
                this.itensListaFornecedor.forEach((item) => {
                  item.qtde = this.Helpers.formatarValor(item.qtde);
                  item.qtde_pendente = this.Helpers.formatarValor(
                    item.qtde_pendente
                  );
                  item.qtde_entregue = this.Helpers.formatarValor(
                    item.qtde_entregue
                  );
                  item.qtde_itens_transito = this.Helpers.formatarValor(
                    item.qtde_itens_transito
                  );
                });
              }
            } else {
              this.itensListaFornecedor = [];
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    activeDialogComprador() {
      this.dialogListaFornecedor = true;
      this.itensListaFornecedor = [];

      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        comprador: this.comprador.id,
        grupo: this.grupoCompra,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DashboardAPI.getListaFornecedoresComptadorTabelaGrupo(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              response.data.fornecedores.forEach((fornecedor) => {
                fornecedor.icon_compra = "mdi-cart";
              });

              this.itensListaFornecedor = response.data.fornecedores;

              if (this.itensListaFornecedor.length) {
                this.itensListaFornecedor.forEach((item) => {
                  item.qtde = this.Helpers.formatarValor(item.qtde);
                  item.qtde_pendente = this.Helpers.formatarValor(
                    item.qtde_pendente
                  );
                  item.qtde_entregue = this.Helpers.formatarValor(
                    item.qtde_entregue
                  );
                  item.qtde_itens_transito = this.Helpers.formatarValor(
                    item.qtde_itens_transito
                  );
                });
              }
            } else {
              this.itensListaFornecedor = [];
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    activeDialogSegmento() {
      this.dialogListaSegmentosComprador = true;
      this.itensListaSegmentosComprador = [];

      this.segmento.codigo = this.getFornecedor.idfamilia_produto;
      this.segmento.nome_completo = this.getFornecedor.descricao_segmento;

      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupoCompra,
        categoria: this.getFornecedor.idSegmento,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DashboardAPI.getListaSegmentosComprador(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            let id = 0;

            if (response.status == 200) {
              response.data.segmentos.forEach((categoria) => {
                id++;
                categoria.id = id;
                categoria.icon_compra = "mdi-cart";
              });

              this.itensListaSegmentosComprador = response.data.segmentos;
            } else {
              this.itensListaSegmentosComprador = [];
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    routerPushGrupo(rota) {
      if (rota === "function") {
        if (this.getFornecedor.tipo == 2) {
          this.activeDialogComprador();
        } else if (this.getFornecedor.tipo == 3) {
          this.activeDialogSegmento();
        }
      } else {
        this.$router.push({ name: rota });
      }
    },

    setarItensBreadcrumb() {
      this.items = [];

      this.items.push({
        text: "Dashboard",
        disabled: true,
        href: "/dashboard",
        rota: "Dashboard",
        title: "",
      });

      if (this.getFornecedor.tipo == 2) {
        this.items.push({
          text: "Comprador",
          disabled: false,
          href: "/dashboard",
          rota: "function",
          title: "",
        });
      } else if (this.getFornecedor.tipo == 3) {
        this.items.push({
          text: "Segmento",
          disabled: false,
          href: "/dashboard",
          rota: "function",
          title: "",
        });
      }

      let razao;

      if (this.getFornecedor.razao_social.length > 20) {
        razao = this.getFornecedor.razao_social.substr(0, 20) + " ...";
      } else {
        razao = this.getFornecedor.razao_social;
      }

      this.items.push({
        text: `${razao}`,
        disabled: false,
        href: "",
        rota: "Dashboard",
        title: `${this.getFornecedor.razao_social}`,
        config: true,
      });
    },

    buscarFornecedores() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupoCompra,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DashboardAPI.getFornecedoresLista(headers, params)
          .then((response) => {
            const { token, fornecedores } = response.data;
            localStorage.setItem("token", token);

            this.$store.dispatch("loading/habilitarLoading", false);
            this.fornecedores = fornecedores;
          })
          .catch(() => {
            this.$store.dispatch("loading/habilitarLoading", false);
            this.Helpers.logout();
          })
      );
    },

    activerow(item) {
      this.selectedId = `${item.id}-${item.id_grupo}`;
      this.$set(item, "selected", true);
    },

    exportarFornecedoresEmRessuprimento() {
      const params = `grupo/${this.grupoCompra}/comprador/${this.comprador.id}`;
      window.open(`${$axios.defaults.baseURL}/reports/fornecedores-em-ressuprimento/${params}`, "_blank");
    }
  },
};
</script>
<style scoped>
.systock-breadcrump {
  background-color: #042333;
  height: 2.5em;
}

#qtde-silenciados {
  margin: 0;
}

.selected_row {
  background-color: rgba(224, 224, 224, 1) !important;
}
</style>

<style>
.font-padrao-input {
  font-size: 12px;
}
.font-padrao-label label {
  font-size: 12px;
}
</style>
